import { Fragment } from 'react'
import { SelectFilterDefinition } from '../types'
import { Text } from '$components'
import { CheckIcon } from '$components'
import { useFilters } from '../hooks/use-filters'

export type SelectFilterOptionProps = {
  filter: SelectFilterDefinition
}

export function SelectFilterOption({ filter }: SelectFilterOptionProps) {
  const { setFilter, getFilter } = useFilters()

  return (
    <Fragment>
      { filter.options.map((option) => (
        <button
          key={option.id}
          className="w-full p-stack-roomy sm:px-stack sm:py-stack-tight focus:outline-none hover:bg-bg-subtle/50 flex items-center gap-stack justify-between cursor-pointer hover:rounded-surface sm:hover:rounded-none"
          onClick={(e) => {
            e.preventDefault()

            setFilter(filter, option.id)
          }}
        >
          <div className="flex items-center gap-stack-tight min-w-0">
            {option.icon && (
              <div className="flex-shrink-0">
                {option.icon}
              </div>
            )}

            <Text
              type="s"
              className="truncate"
            >
              { option.label }
            </Text>
          </div>

          { option.id === getFilter(filter) && (
            <CheckIcon className="size-4 text-brand-hover" />
          )}
        </button>
      ))}
    </Fragment>
  )
}
